/** Vite `base` without trailing slash (e.g. '' for hortera.org root, '/web/garden-hub' for legacy). */
export function getAppBasename(): string {
	return (import.meta.env.BASE_URL ?? '/').replace(/\/$/, '');
}

/** PHP API base URL without trailing slash. */
export function getApiBaseUrl(): string {
	const raw =
		import.meta.env.VITE_API_BASE_URL ??
		(import.meta.env.MODE === 'production' ? '/api' : 'http://localhost:8080');
	return String(raw).trim().replace(/\/+$/, '');
}

/**
 * Build a full API URL. Accepts `/upload`, `/analyze-garden-image`, or legacy `/api/upload`.
 * Avoids `/api/api/...` when VITE_API_BASE_URL already ends with `/api`.
 */
export function buildApiUrl(endpoint: string): string {
	const base = getApiBaseUrl();
	let path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
	if (path.startsWith('/api/')) {
		path = path.slice(4); // "/api/foo" -> "/foo"
	} else if (path === '/api') {
		path = '';
	}
	return `${base}${path}`;
}

/** Public site origin for share links and PDFs. */
export function getAppOrigin(): string {
	if (typeof window !== 'undefined' && window.location.origin) {
		return window.location.origin;
	}
	const envUrl =
		import.meta.env.VITE_PUBLIC_SITE_URL ||
		import.meta.env.VITE_APP_HOMEPAGE_URL ||
		import.meta.env.VITE_SITE_URL;
	if (typeof envUrl === 'string' && envUrl.trim()) {
		return envUrl.trim().replace(/\/+$/, '');
	}
	return import.meta.env.PROD ? 'https://hortera.org' : 'http://localhost:5173';
}

/** Absolute app URL (e.g. https://hortera.org/?invite=abc). */
export function buildAppUrl(pathAndQuery = ''): string {
	const basename = getAppBasename();
	const suffix = pathAndQuery.startsWith('/') || pathAndQuery.startsWith('?')
		? pathAndQuery
		: `/${pathAndQuery}`;
	return `${getAppOrigin()}${basename}${suffix}`;
}
